import 'mapbox-gl/dist/mapbox-gl.css';

import { useSearchParams } from 'react-router-dom';

import { SecondaryNav } from '@/components';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { usePlot } from '@/pages/shared/hooks/usePlot';
import { buildPath } from '@/utils/buildPath';

import { PlotInteractiveMap } from './components/PlotInteractiveMap';

export const InteractiveMapPage = () => {
  const menuItems = useMenuItems();
  const pathSet = usePathSet();

  const plot = usePlot().data;

  const workstreamId = useWorkstreamId();
  const [searchParams] = useSearchParams();
  const plotGroupId = searchParams.get('plotGroupId');

  const plotDetailPath = buildPath(pathSet.plot, {
    pathParams: { plotId: plot.id },
    ...(plotGroupId && { plotGroupId }),
    ...(workstreamId && { workstreamId }),
  });

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer className='h-full'>
      <SecondaryNav title={plot.name} backPath={plotDetailPath} />
      <PlotInteractiveMap plot={plot} />
    </SignedInPageLayout>
  );
};
